export default "__VITE_ASSET__Bphuvhy7__"